/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpaymentpendingmessage4Inputs */



/**
* | output |
* | --- |
* | "The store is still confirming your payment. Your subscription will turn on as soon as it goes through." |
*
* @param {Subscriptionalertpaymentpendingmessage4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpaymentpendingmessage4 = /** @type {((inputs?: Subscriptionalertpaymentpendingmessage4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpaymentpendingmessage4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The store is still confirming your payment. Your subscription will turn on as soon as it goes through.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La tienda todavía está confirmando tu pago. La suscripción se activará en cuanto se complete.")
	return /** @type {LocalizedString} */ ("Магазин ещё подтверждает платёж. Подписка включится, как только оплата пройдёт.")
});
export { subscriptionalertpaymentpendingmessage4 as "subscriptionAlertPaymentPendingMessage" }